module.exports = __webpack_public_path__ + "static/media/mobile_theme.dd2561aa.png";